import React, { useEffect, useState } from 'react';
import { Pie } from '@nivo/pie';

import useGetChartsData from '../hooks/useGetChartsData';
import BarChart from './barChart';

export default function Charts() {
  const [statusData, setStatusData] = useState([]);

  const getChartsData = useGetChartsData();

  useEffect(() => {
    const finalData = [];
    if (getChartsData?.data?.data) {
      const keys = Object.keys(getChartsData?.data?.data?.status);
      keys?.map((item) => {
        finalData.push({
          id: item,
          label: item,
          value: getChartsData?.data?.data?.status?.[`${item}`],
        });
        return true;
      });
      setStatusData(finalData);
    }
  }, [getChartsData?.data?.data]);

  return (
    <div>
      <div className='flex space-x-6 pb-6'>
        <div className='w-1/3 border p-4 border-gray border-opacity-10 rounded-lg shadow-lg'>
          <p className='text-gray text-lg font-bold'>Status</p>
          <Pie
            width={400}
            height={220}
            data={statusData}
            margin={{
              top: 20,
              right: 40,
              bottom: 20,
              left: 40,
            }}
            innerRadius={0.75}
            padAngle={0.7}
            enableArcLabels={false}
            enableArcLinkLabels={false}
            cornerRadius={3}
            activeOuterRadiusOffset={8}
            arcLinkLabelsSkipAngle={10}
            arcLinkLabelsTextColor='#333333'
            arcLinkLabelsThickness={2}
            arcLinkLabelsColor={{ from: 'color' }}
            arcLabelsSkipAngle={10}
            isInteractive={false}
            arcLabelsTextColor='#333333'
            defs={[
              {
                id: 'dots',
                type: 'patternDots',
                background: 'rgba(130, 130, 130)',
                color: 'rgba(130, 130, 130)',
                size: 4,
                padding: 1,
                stagger: true,
              },
              {
                id: 'lines',
                type: 'patternDots',
                background: 'rgba(29, 117, 231)',
                color: 'rgba(29, 117, 231)',
                size: 4,
                padding: 1,
                stagger: true,
              },
              {
                id: 'almost',
                type: 'patternDots',
                background: 'rgba(209, 52, 56)',
                color: 'rgba(209, 52, 56)',
                size: 4,
                padding: 1,
                stagger: true,
              },
              {
                id: 'complete',
                type: 'patternDots',
                background: 'rgba(40, 180, 70)',
                color: 'rgba(40, 180, 70)',
                size: 4,
                padding: 1,
                stagger: true,
              },
            ]}
            fill={[
              {
                match: {
                  id: 'not_started',
                },
                id: 'dots',
              },
              {
                match: {
                  id: 'in_progress',
                },
                id: 'lines',
              },
              {
                match: {
                  id: 'late',
                },
                id: 'almost',
              },
              {
                match: {
                  id: 'completed',
                },
                id: 'complete',
              },
            ]}
          />
          <div className='text-gray2 space-y-2 pl-32 mt-2'>
            <div className='flex items-center space-x-2'>
              <span className='w-4 h-4 bg-[#828282] p-1 rounded-full'></span>
              <p>Not started</p>
            </div>
            <div className='flex items-center space-x-2'>
              <span className='w-4 h-4 bg-[#1D75E7] p-1 rounded-full'></span>
              <p>In progress</p>
            </div>
            <div className='flex items-center space-x-2'>
              <span className='w-4 h-4 bg-[#d13438] p-1 rounded-full'></span>
              <p>Late</p>
            </div>
            <div className='flex items-center space-x-2'>
              <span className='w-4 h-4 bg-[#28B446] p-1 rounded-full'></span>
              <p>Completed</p>
            </div>
          </div>
        </div>

        {/* buckets graph */}
        <div className='w-2/3 border border-gray p-4 border-opacity-10 rounded-lg shadow-lg'>
          <p className='text-gray text-lg font-bold'>Bucket</p>
          <div className='w-full flex justify-center'>
            <BarChart
              data={getChartsData?.data?.data?.bucket || []}
            
              layout='vertical'
              name='bucket'
              
            />
           
          </div>
        </div>
      </div>
      <div className='flex space-x-6 mb-8'>
        {/* Priority graph */}
        <div className='w-1/2 border border-gray p-4 border-opacity-10 rounded-lg shadow-lg'>
          <p className='text-gray text-lg font-bold'>Priority</p>
          <BarChart
            data={getChartsData?.data?.data?.priority || []}
            layout='vertical'
            name='priority'
          />
        </div>
        {/* members graph */}
        <div className='w-1/2 border border-gray p-4 border-opacity-10 rounded-lg shadow-lg'>
          <p className='text-gray text-lg font-bold'>Members</p>
          <BarChart
            data={getChartsData?.data?.data?.members || []}
            layout='horizontal'
            name='members'
          />
        </div>
      </div>
    </div>
  );
}
